.skipLink {
    position: absolute;
    top: -100%;
    left: var(--spacer-16);
    z-index: 150;

    [data-design-version="v2026"] & {
        font: var(--font-nav-14);
    }

    &:focus-visible {
        top: var(--spacer-4);
    }
}
